// 页面过渡动画组件
import { useState, useEffect, useRef } from 'react'

export default function PageTransition({ children, pageKey }) {
  const [isAnimating, setIsAnimating] = useState(false)
  const prevKeyRef = useRef(pageKey)

  useEffect(() => {
    // 只在"真正进入新页面"时触发动画（不是底部Tab切换）
    // 通过判断 pageKey 是否从隐藏导航的页面切换过来
    const prev = prevKeyRef.current
    const HIDE_NAV = ['home', 'detail', 'settings', 'search', 'login', 'video', 'identity',
      'homework', 'homeworkList', 'homeworkCreate', 'homeworkHistory',
      'mistakeBook', 'learnTrack', 'teacherDashboard', 'aiRecommend', 'privacy', 'terms']

    // 从隐藏导航的页面进入显示导航的页面时，才播放动画
    if (HIDE_NAV.includes(prev) && !HIDE_NAV.includes(pageKey)) {
      setIsAnimating(true)
      const timer = setTimeout(() => setIsAnimating(false), 250)
      prevKeyRef.current = pageKey
      return () => clearTimeout(timer)
    }

    prevKeyRef.current = pageKey
    setIsAnimating(false)
  }, [pageKey])

  return (
    <div className={isAnimating ? 'page-enter-animation' : ''} style={{ height: '100%' }}>
      <style>{`
        .page-enter-animation {
          animation: pageEnter 0.25s ease-out forwards;
        }
        @keyframes pageEnter {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      {children}
    </div>
  )
}

// 淡入淡出过渡
export function FadeTransition({ children, show }) {
  return (
    <div style={{
      opacity: show ? 1 : 0,
      transition: 'opacity 0.3s ease',
      pointerEvents: show ? 'auto' : 'none'
    }}>
      {children}
    </div>
  )
}

// 缩放过渡（用于模态框）
export function ScaleTransition({ children, show }) {
  return (
    <div style={{
      opacity: show ? 1 : 0,
      transform: show ? 'scale(1)' : 'scale(0.9)',
      transition: 'all 0.3s ease',
      pointerEvents: show ? 'auto' : 'none'
    }}>
      {children}
    </div>
  )
}
